import { Calendar, Package } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ProductCard({ product, onClick }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.startsWith("ar");

  const name = product?.name || t("products.unknown");
  const family = product?.family?.name || t("products.noCategory");
  const casNumber = product?.cas_number || "N/A";
  const supplier = product?.supplier?.name || t("products.unknownSupplier");
  const date = product?.date
    ? product.date.split(" ")[0]
    : t("products.noDate");

const safePrice =
  product?.quantity_type?.cost_per_kilo !== null &&
  product?.quantity_type?.cost_per_kilo !== undefined &&
  product?.quantity_type?.cost_per_kilo !== "" &&
  !isNaN(Number(product.quantity_type.cost_per_kilo))
    ? Number(product.quantity_type.cost_per_kilo).toLocaleString()
    : null;

  const qType = product?.quantity_type;
  const costPerKilo =
    qType?.cost_per_kilo !== null &&
    qType?.cost_per_kilo !== undefined &&
    !isNaN(qType.cost_per_kilo)
      ? Number(qType.cost_per_kilo).toLocaleString()
      : null;

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      dir={isRtl ? "rtl" : "ltr"}
      onKeyDown={(e) => {
        if (e.key === "Enter" && onClick) onClick();
      }}
      style={{
        background: "#ffffff",
        border: "1px solid #e9f0eb",
        borderRadius: "18px",
        padding: "20px",
        cursor: "pointer",
        transition: "all 0.22s ease",
        position: "relative",
        outline: "none",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        height: "auto",
        overflow: "visible",
        textAlign: isRtl ? "right" : "left",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#0c6839";
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 10px 28px rgba(12,104,57,0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#e9f0eb";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "10px",
          marginBottom: "14px",
          width: "100%",
        }}
      >
        <h3
          style={{
            fontSize: "15px",
            fontWeight: "700",
            color: "#1a1f1c",
            lineHeight: "1.4",
            flex: "1",
            wordBreak: "break-word",
            margin: "0",
          }}
        >
          {name}
        </h3>

        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: "11px",
            color: "#9ca3af",
            flexShrink: "0",
            whiteSpace: "nowrap",
          }}
        >
          <Calendar size={12} />
          {date}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          gap: "6px",
          flexWrap: "wrap",
          marginBottom: "16px",
          width: "100%",
        }}
      >
        <span
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: "#0c6839",
            background: "rgba(12,104,57,0.1)",
            padding: "4px 12px",
            borderRadius: "20px",
          }}
        >
          {family}
        </span>

        <span
          style={{
            fontSize: "11px",
            color: "#6b7280",
            background: "#f3f4f6",
            padding: "4px 10px",
            borderRadius: "20px",
            fontFamily: "monospace",
          }}
        >
          CAS: {casNumber}
        </span>

        {qType?.name && (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: "600",
              color: "#7c3aed",
              background: "rgba(124,58,237,0.08)",
              padding: "4px 10px",
              borderRadius: "20px",
            }}
          >
            <Package size={11} />
            {qType.name}
          </span>
        )}
        {/* {qType?.size && (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: "600",
              color: "#7c3aed",
              background: "rgba(124,58,237,0.08)",
              padding: "4px 10px",
              borderRadius: "20px",
            }}
          >
            <Package size={11} />
            {qType.size} {t("products.kg")}
          </span>
        )} */}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          paddingTop: "14px",
          borderTop: "1px solid #f0f4f1",
          marginTop: "auto",
          gap: "12px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            flex: "1",
            minWidth: "0",
          }}
        >
          <span style={{ fontSize: "11px", color: "#9ca3af" }}>
            {t("products.source")}:
          </span>
          <span
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#0c6839",
              wordBreak: "break-word",
            }}
          >
            {supplier}
          </span>

          {/* {costPerKilo && (
            <span
              style={{
                fontSize: "11px",
                color: "#9ca3af",
                marginTop: "4px",
              }}
            >
              {t("products.pricePerKilo")}: {t("products.currency")}{" "}
              {costPerKilo}/{t("products.kg")}
            </span>
          )} */}

          {/* {qType?.kilos && (
            <span
              style={{
                fontSize: "11px",
                color: "#9ca3af",
                marginTop: "2px",
              }}
            >
              {t("products.packageWeight")}: {qType.kilos} {t("products.kg")}
            </span>
          )} */}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: isRtl ? "flex-start" : "flex-end",
            gap: "2px",
            flexShrink: "0",
          }}
        >
          {/* <span style={{ fontSize: "11px", color: "#9ca3af" }}>
            {t("products.currentPrice")}
          </span> */}

          {safePrice ? (
            <span
              style={{
                fontSize: "17px",
                fontWeight: "700",
                color: "#1a1f1c",
                whiteSpace: "nowrap",
              }}
            >
              {t("products.currency")} {safePrice}
            </span>
          ) : (
            <span style={{ fontSize: "13px", color: "#9ca3af" }}>
              {t("products.noPrice")}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
